/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './SeasonKeyword.module.scss';
import { useDebounce } from '../../../hooks';
import { getAdvSearchBusinessData, getDecsCities } from '../../../api';
import Toast from '../../common/Toast/Toast';
import { onClickEvent } from '../../../lib/gaAnalytics';
import { isNumRegex, isValidMobileNum } from '../../../lib/common';
import { useAuth } from '../../../contexts/auth';

export default function GenioLandingPage() {
  const searchTypes = ['Business Name', 'Doc Id', 'Phone Number'];
  const [selectedSearchType, setSelectedSearchType] = useState('Business Name');
  const [searchedBusinessData, setSearchedBusinessData] = useState(
    JSON.parse(localStorage.getItem('searchedBusinessData')) || [],
  );

  const [authState] = useAuth();
  const profile = JSON.parse(sessionStorage.getItem('profileDetails'));
  const [loading, setLoading] = useState(false);
  const [selectedAndSearchCity, setSelectedAndSearchCity] = useState({
    selectedCity: authState?.profileDetails?.city || profile?.city || '',
    searchCityText: '',
    businessSearchValue: '',
    businessSearchInputErr: '',
  });
  const [citiesData, setCitiesData] = useState({});
  const [citiesRes, setCitiesRes] = useState([]);
  const debouncedSearchText = useDebounce(selectedAndSearchCity?.businessSearchValue || '', 500);
  const [cityParam, setCityParam] = useState(selectedAndSearchCity?.selectedCity || '');
  const [businessesData, setBusinessesData] = useState([]);
  const [showCities, setShowCities] = useState(false);
  const [selectedOption, setSelectedOption] = useState('');
  const [toastMsgObj, settoastMsgObj] = useState({
    message: '',
    status: '',
  });
  const navigate = useNavigate();
  const options = [
    { label: 'No Callback Required', value: 'self', title: 'CS will not initiate a call' },
    { label: 'Callback to Client', value: 'client', title: 'CS will call the client' },
  ];

  useEffect(() => {
    localStorage.removeItem('selectedBusinessGenio');
    const handleGetDecsCities = async () => {
      try {
        const cities = await getDecsCities(1);
        if (cities && Object.keys(cities).length > 0) {
          const citiesArr = Object.entries(cities);
          const sortedCities = Object.fromEntries(citiesArr.sort((a, b) => a[0].localeCompare(b[0])));
          setCitiesData(Object.keys(sortedCities).length > 0 ? sortedCities : {});
          setCitiesRes(Object.keys(sortedCities).length > 0 ? sortedCities : {});
        }
      } catch (e) {
        console.log('Error: ', e);
      }
    };
    handleGetDecsCities();
  }, []);

  const handleSearchCity = (e) => {
    setShowCities(e.target.value !== '');

    setSelectedAndSearchCity({
      ...selectedAndSearchCity,
      searchCityText: e.target.value,
      selectedCity: e.target.value,
    });

    const filteredCitiesData = Object.fromEntries(
      Object.entries(citiesRes).filter(([key]) => key.toLowerCase().includes(e.target.value.toLowerCase())),
    );
    setCitiesData(filteredCitiesData);
  };

  const handleSelectedCity = async (city) => {
    setShowCities(false);
    setCityParam(citiesData?.[city]?.data_city || '');
    onClickEvent(`GENIO-Search Page-City Name`, city, city);
    setSelectedAndSearchCity({
      selectedCity: city,
      searchCityText: '',
    });
    setCitiesData(citiesRes);
  };

  useEffect(() => {
    const handleGetAdvSearchBusinessData = async () => {
      try {
        if (
          debouncedSearchText &&
          selectedAndSearchCity?.selectedCity &&
          !selectedAndSearchCity?.businessSearchInputErr
        ) {
          setLoading(true);
          const params = {
            city: cityParam || '',
            companyName: '',
            phone: '',
            docId: '',
            // parentId: '',
          };
          if (selectedSearchType === 'Business Name') {
            params.companyName = selectedAndSearchCity?.businessSearchValue || '';
          } else if (selectedSearchType === 'Doc Id') {
            params.docId = selectedAndSearchCity?.businessSearchValue || '';
          } else if (selectedSearchType === 'Phone Number') {
            params.phone = selectedAndSearchCity?.businessSearchValue || '';
          }

          const res = await getAdvSearchBusinessData(params);
          setBusinessesData(res?.errorCode === 0 ? res?.result : []);
          setLoading(false);
        } else {
          setBusinessesData([]);
        }
      } catch (err) {
        console.error('Error: ', err);
      }
    };
    handleGetAdvSearchBusinessData();
  }, [debouncedSearchText]);

  const handleBusinessClick = (data, clickId = '') => {
    onClickEvent(`GENIO-Search Page-Business Name`, data?.companyName || '', data?.companyName || '');
    const storedDataArr = searchedBusinessData?.filter((each) => each?.parentId === data?.parentId);
    if (searchedBusinessData && searchedBusinessData?.length === 5) {
      searchedBusinessData.pop();
    }
    if (
      clickId === 'searchBusiness' &&
      searchedBusinessData &&
      searchedBusinessData.length < 5 &&
      storedDataArr?.length === 0
    ) {
      const updatedBusinessData = [data, ...searchedBusinessData];
      localStorage.setItem('searchedBusinessData', JSON.stringify(updatedBusinessData));
    }
    const businessCity = data?.city?.toLowerCase?.() || '';
    const cityEntry =
      Object.entries(citiesRes || {})?.find(
        ([key, val]) =>
          businessCity && (key?.toLowerCase?.() === businessCity || val?.data_city?.toLowerCase?.() === businessCity),
      )?.[1] ||
      citiesRes?.[selectedAndSearchCity?.selectedCity] ||
      {};
    const updatedDataWithConcern = {
      ...data,
      concern: selectedOption || '',
      cityDetails: {
        data_city: cityEntry?.data_city || '',
        dialer_mapped_cityname: cityEntry?.dialer_mapped_cityname || '',
      },
    };

    localStorage.setItem('selectedBusinessGenio', JSON.stringify(updatedDataWithConcern || {}));
    navigate('/genio/features');
  };

  const handleDeleteAll = () => {
    localStorage.removeItem('searchedBusinessData');
    setSearchedBusinessData([]);
  };

  const handleDeleteBusiness = (parentId) => {
    const updatedBusinessData = searchedBusinessData.filter((each) => each.parentId !== parentId);
    localStorage.setItem('searchedBusinessData', JSON.stringify(updatedBusinessData));
    setSearchedBusinessData(updatedBusinessData);
  };

  const handleBusinessSearchInput = (val) => {
    if (selectedSearchType === 'Business Name') {
      if (val && val.length > 300) {
        setSelectedAndSearchCity({
          ...selectedAndSearchCity,
          businessSearchInputErr: 'Company name should not exceed 300 characters.',
        });
      } else {
        setSelectedAndSearchCity({
          ...selectedAndSearchCity,
          businessSearchValue: val,
          businessSearchInputErr: '',
        });
      }
    } else if (selectedSearchType === 'Doc Id') {
      const regex = /[`!@#$%^&*()_+\-=[\]{};':"\\|,<>/?~]/;
      if (val && regex.test(val)) {
        setSelectedAndSearchCity({
          ...selectedAndSearchCity,
          businessSearchInputErr: 'Please avoid special characters.',
        });
      } else if (val.length > 50) {
        setSelectedAndSearchCity({
          ...selectedAndSearchCity,
          businessSearchInputErr: 'Doc ID should not exceed 50 characters.',
        });
      } else {
        setSelectedAndSearchCity({
          ...selectedAndSearchCity,
          businessSearchValue: val,
          businessSearchInputErr: '',
        });
      }
    } else if (selectedSearchType === 'Phone Number') {
      if ((val && val.length <= 10 && !isNumRegex(val)) || (val && val.length > 10 && !isValidMobileNum(val))) {
        setSelectedAndSearchCity({
          ...selectedAndSearchCity,
          businessSearchInputErr: 'Mobile number should be 10 digits only.',
        });
      } else {
        setSelectedAndSearchCity({
          ...selectedAndSearchCity,
          businessSearchValue: val,
          businessSearchInputErr: '',
        });
      }
    }
  };

  useEffect(() => {
    localStorage.setItem('searchedBusinessData', JSON.stringify(searchedBusinessData));
  }, [searchedBusinessData]);

  useEffect(() => {
    if (authState?.profileDetails?.city) {
      setSelectedAndSearchCity({
        ...selectedAndSearchCity,
        selectedCity: authState?.profileDetails?.city || profile?.city || '',
      });
      setCityParam(authState?.profileDetails?.city || profile?.city || '');
    }
  }, [authState?.profileDetails]);

  const businessList = (data, typeId = '') => {
    return (
      <ul className={`${styles.Keyword__SearchList}`}>
        {data.map((each, index) => (
          <li key={index} className={`${styles.Keyword__SearchItem}`}>
            <div
              aria-label="genio_redirection_click"
              tabIndex={0}
              role="button"
              onKeyDown={() => {}}
              style={{ cursor: selectedOption ? 'pointer' : 'not-allowed' }}
              onClick={() => {
                if (!selectedOption) {
                  settoastMsgObj({
                    message: 'Please select a concern first',
                    status: 'false',
                  });
                  return;
                }
                handleBusinessClick(each, typeId === 'searchBusiness' ? 'searchBusiness' : '');
              }}
              className={`${styles.Keyword__SearchName} font14 fw500 color111 pr-30`}
            >
              {each?.companyName}
            </div>
            <div className={`${styles.Keyword__SearchId} font12 fw400 color777`}>{each?.parentId}</div>
            <div className={`${styles.Keyword__SearchInfo}`}>
              <div className={`${styles.Keyword__SearchLocat} font12 fw400 color777 capitalize`}>{each?.city}</div>
              {each?.status === 'PAID' && (
                <div className={`${styles.Keyword__Status} font12 fw400 color339 pl-5`}> • {each?.status}</div>
              )}
            </div>
            {typeId === 'storedBusiness' && (
              <div
                aria-label="genio_del_business"
                tabIndex={0}
                role="button"
                onKeyDown={() => {}}
                onClick={() => handleDeleteBusiness(each?.parentId)}
                className={`${styles.SearchClear__Icon} csicon`}
              />
            )}
          </li>
        ))}
      </ul>
    );
  };
  return (
    <>
      <div className="pb-20 mt-10">
        <div className={`${styles.Keyword__Location} pl-20 pr-20`}>
          <div className="form_group_box mt-25" style={{ borderRadius: '10px' }}>
            <div className="form_group">
              <input
                value={selectedAndSearchCity?.selectedCity}
                onChange={(e) => handleSearchCity(e)}
                className="input font12 fw500 color111 pl-10"
                type="search"
                required
                style={{ background: 'transparent', textAlign: 'left' }}
              />
              <span className="inputbar" />
              <label className="input_label font12 fw500 color777">
                Select City
                <span className="colorF45">*</span>
              </label>
              <div className="input__dropdown" style={{ display: showCities ? 'block' : 'none' }}>
                <ul className="input__droplist">
                  {citiesData &&
                    Object.keys(citiesData).length > 0 &&
                    Object.keys(citiesData).map((each, idx) => (
                      <li className="input__dropitem" key={idx}>
                        <div
                          tabIndex={0}
                          role="button"
                          onKeyDown={() => {}}
                          onClick={() => handleSelectedCity(each)}
                          className="input__dropanchor  font12 fw400 color111"
                        >
                          {each}
                        </div>
                      </li>
                    ))}
                </ul>
              </div>
            </div>
          </div>
          <div className={styles.SelectField}>
            <label htmlFor="concern" className={styles.SelectField__label}>
              Concern <span className="colorF45">*</span>
            </label>

            <select
              id="concern"
              className={styles.SelectField__input}
              value={selectedOption}
              onChange={(e) => {
                setSelectedOption(e.target.value);
              }}
            >
              <option value="" disabled>
                Select concern
              </option>
              {options.map((item) => (
                <option key={item.value} value={item.value} title={item.title}>
                  {item.label}
                </option>
              ))}
            </select>

            <span className={`${styles.SelectField__icon} csicon`} />
          </div>
        </div>

        <ul className={`${styles.Keyword__TypeList} mt-20 pl-20`}>
          {searchTypes.map((eachType, idx) => (
            <li
              key={idx}
              className={`${styles.Keyword__TypeItem} ${selectedSearchType === eachType && styles.Active} font12 fw500`}
            >
              <div
                tabIndex={0}
                role="button"
                onKeyDown={() => {}}
                onClick={() => {
                  setSelectedSearchType(eachType);
                  setSelectedAndSearchCity({
                    ...selectedAndSearchCity,
                    businessSearchValue: '',
                    businessSearchInputErr: '',
                  });
                }}
              >
                {eachType}
              </div>
            </li>
          ))}
        </ul>
        <div className="pl-20 pr-20 pt-30">
          <div className={`${styles.Keyword__InputBox} `}>
            <input
              onChange={(e) => handleBusinessSearchInput(e.target.value)}
              value={selectedAndSearchCity?.businessSearchValue || ''}
              className={`${styles.Keyword__Input} font13 fw500 color111`}
              type="search"
            />
            <div className={`${styles.Search__Icon} csicon`} />
          </div>
          {selectedAndSearchCity?.businessSearchInputErr && (
            <span className="colorEC4 font12">{selectedAndSearchCity?.businessSearchInputErr}</span>
          )}
        </div>

        {loading ? (
          <div className="loader-div mt-30">
            <div className="bt-spinner" style={{ height: '25px', width: '25px' }} />
          </div>
        ) : (
          <>
            {!selectedAndSearchCity?.businessSearchValue ? (
              <>
                {searchedBusinessData && searchedBusinessData?.length > 0 && (
                  <div className={`${styles.Keyword__SearchBox} pl-20 pr-20 pt-15`}>
                    <div className={`${styles.Keyword__SearchRecent}`}>
                      <div className="font12 fw500 color777">Recent Search</div>
                      <div
                        tabIndex={0}
                        role="button"
                        onKeyDown={() => {}}
                        onClick={handleDeleteAll}
                        className="font11 fw500 color007 pointer"
                      >
                        Clear All
                      </div>
                    </div>
                    {businessList(searchedBusinessData || [], 'storedBusiness')}
                  </div>
                )}
              </>
            ) : (
              <>
                {businessesData && businessesData.length > 0 && (
                  <div className={`${styles.Keyword__SearchBox} pl-20 pr-20 pt-15`}>
                    {businessList(businessesData || [], 'searchBusiness')}
                  </div>
                )}
                {debouncedSearchText &&
                  businessesData &&
                  businessesData?.length === 0 &&
                  selectedAndSearchCity?.businessSearchValue &&
                  !selectedAndSearchCity?.businessSearchInputErr && <div className="no-data-div">No Data</div>}
              </>
            )}
          </>
        )}
      </div>
      {toastMsgObj?.message && <Toast toastMsgObj={toastMsgObj} />}
    </>
  );
}
